import React from 'react';
import { Route } from 'react-router-dom';

import PautasFicha from '../../Pautas/pautas/PautasFicha';
import PautasIndex from '../../Pautas/pautas/PautasIndex';

const PautasRoutes = () => {
  return (
    <>
      {/* Pautas */}
      <Route path="pautas/pautas" element={<PautasIndex />} />
      <Route path="pautas/pautas/ficha/dadosgerais" element={<PautasFicha />} />
      <Route
        path="pautas/pautas/ficha/:id/dadosgerais"
        element={<PautasFicha />}
      />
    </>
  );
};

export default PautasRoutes;
